export default {
  errorMsg: {
    serverOffline: 'Fehler beim Verbinden mit dem Server, bitte versuchen Sie es erneut.',
  },
}
